import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import LandingPage from "./pages/LandingPage";
import "./index.css";

// To calm phones down again: add a `useIsPhone` width hook (innerWidth < 768)
// and pass `reducedMotion={isPhone ? "always" : "user"}` to MotionConfig below,
// plus re-enable the width check in lib/motionShim.js.

// Secondary routes load on demand — the home page ships alone.
const ProductPage = lazy(() => import("./pages/ProductPage"));
const WaitlistPage = lazy(() => import("./pages/WaitlistPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));

const Shell = () => <div className="min-h-screen" style={{ background: "#07070a" }} />;

// Every route change starts at the top — the router otherwise keeps the old
// scroll position. Links with a hash (/#tools, /#faq …) scroll to that section
// instead, once the destination page has mounted.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(
        () => document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' }),
        350
      );
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

function App() {
  // Animations currently ON for all devices; switch back to
  // `useIsPhone() ? "always" : "user"` to calm phones down again.
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<Shell />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
